import React, { useEffect, useState, useRef } from "react";
import Logo from "../../assets/logo.png";
import { RiMenuFold2Line } from "react-icons/ri";
import { IoMdMenu } from "react-icons/io";
import { FaFlagUsa } from "react-icons/fa";

const Navbar = () => {
  const List = [
    { name: "Home", link: "/" },
    { name: "About", link: "/about-us" },
    { name: "Services", link: "/services" },
    { name: "Projects", link: "/projects" },
    { name: "Contact", link: "/contact-us" },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };
  const handeClickOutSide = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handeClickOutSide);
  }, []);

  return (
    <div
      data-aos="fade-down"
      className="fixed top-0 right-0 w-full z-[99] bg-black/10 backdrop-blur-sm "
    >
      <div className="flex justify-between lg:justify-around items-center px-2 text-gray-900">
        <div className="flex items-center gap-4 text-white font-bold text-2xl">
          <img src={Logo} alt="" className="w-20 h-full" />
          <span>ZEMEN</span>
        </div>

        <div className="hidden lg:flex justify-evenly items-center w-1/2 text-xl text-white">
          {List &&
            List.map(
              (item, index) =>
                index !== List.length && ( // Exclude the last item
                  <div key={index}>
                    <a href={item.link} className="cursor-pointer group">
                      <p className="hover:text-cyan-500 duration-300 ease-linear group-hover:-translate-y-1">
                        {item.name}
                      </p>
                      <div className="opacity-0 w-0 border-b border-cyan-400 duration-300 ease-linear group-hover:opacity-100 group-hover:w-full"></div>
                    </a>
                  </div>
                )
            )}
        </div>

        <div className="block lg:hidden">
          {isOpen ? (
            <RiMenuFold2Line
              size={40}
              onClick={toggleOpen}
              className="text-white"
            />
          ) : (
            <IoMdMenu size={40} onClick={toggleOpen} className="text-white" />
          )}
          <div
            className={`fixed top-20 ${
              isOpen ? "right-1/2 translate-x-1/2" : "-right-full"
            } overflow-y-auto w-72 z-50 overflow-hidden opacity-100 duration-500 ease-linear flex justify-end border border-cyan-300 rounded-xl`}
          >
            <div ref={popupRef} className="w-full text-center">
              {List &&
                List.map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className="block p-5 w-72 bg-[#000000b2] text-white hover:bg-cyan-300"
                  >
                    <p>{item.name}</p>
                  </a>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
